const eventCategory = "franchise_interest_page";
export const landingPageEvent = {
    event: "page_loaded",
    eventAction: "page_loaded",
    eventCategory
};

export const downloadBrochureEvent = {
    event: "brochure",
    eventAction: "brochure_downloaded",
    eventCategory
};

export const registerInterestEvent = {
    event: "interest_form",
    eventAction: "interest_form_clicked",
    eventCategory
};

export const interestFormSubmitted = {
    event: "interest_form",
    eventAction: "interest_form_submitted",
    eventCategory
};

export const earningGraphEvent = {
    event: "earnings_graph",
    eventAction: "graph_clicked",
    eventCategory
};
